// Vue
import Vue from 'vue'
import Router from 'vue-router'

// Core Pages
import Home from './views/Home.vue'
import About from './views/About.vue'
import Work from './views/Work.vue'
import NotFound from './views/NotFound.vue'

// Project Pages
import cbddrinks from './views/projects/cbddrinks.vue'
import bigelow from './views/projects/bigelow.vue'
import formfactory from './views/projects/formfactory.vue'
import brush8 from './views/projects/brush8.vue'
import myhealthyweight from './views/projects/myhealthyweight.vue'
import bicduo from './views/projects/bicduo.vue'
import dailyui from './views/projects/dailyui.vue'
import motion from './views/projects/motion.vue'
import milksite from './views/projects/milksite.vue'
import packaging from './views/projects/packaging.vue'
import portfolio from './views/projects/portfolio.vue'
import borgle from './views/projects/borgle.vue'
import figmaplugins from './views/projects/figmaplugins.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      path: '/',
      name: 'home',
      component: Home
    },

    {
      path: '/about',
      name: 'about',
      component: About
    },

    {
      path: '/projects',
      name: 'projects',
      component: Work
    },

    { path: '/projects/bigelow', name: 'bigelow', component: bigelow },
    { path: '/projects/formfactory', name: 'formfactory', component: formfactory },
    { path: '/projects/brush8', name: 'brush8', component: brush8 },
    { path: '/projects/myhealthyweight', name: 'myhealthyweight', component: myhealthyweight },
    { path: '/projects/bicduo', name: 'bicduo', component: bicduo },
    { path: '/projects/dailyui', name: 'dailyui', component: dailyui },
    { path: '/projects/motion', name: 'motion', component: motion },
    { path: '/projects/milksite', name: 'milksite', component: milksite },
    { path: '/projects/packaging', name: 'packaging', component: packaging },
    { path: '/projects/cbddrinks', name: 'cbddrinks', component: cbddrinks },
    { path: '/projects/portfolio', name: 'portfolio', component: portfolio },
    { path: '/projects/borgle', name: 'borgle', component: borgle },
    { path: '/projects/figmaplugins', name: 'figmaplugins', component: figmaplugins },

    {
      path: '/404',
      name: '404',
      component: NotFound
    },
    {
      path: '*',
      redirect: '404'
    },
    {
      path: '*/*',
      redirect: '404'
    },
    {
      path: '/projects/*',
      redirect: '404'
    }
  ]
})
